import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Redirect legacy unsubscribe links to the notification preferences page.
 *
 * Users arrive here from email footers that link to `/dashboard/unsubscribe`.
 * We send them directly to `/dashboard/user-preference` where they can manage
 * notification settings.
 */
export const Route = createFileRoute('/dashboard/_deep-links/unsubscribe')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/user-preference' });
  },
  component: () => null,
});
